export default __webpack_public_path__ + "static/media/Oxygen.3c0e5a25.svg";